import FourthSection from './FourthSection';

export default FourthSection;
